import { Injectable, signal } from '@angular/core'

export type AppTheme = 'light' | 'dark'

const STORAGE_KEY = 'webapps-theme'

@Injectable({ providedIn: 'root' })
export class ThemeService {
    readonly theme = signal<AppTheme>(readStoredTheme())

    constructor() {
        this.apply(this.theme())
    }

    setTheme(theme: AppTheme): void {
        this.theme.set(theme)
        try {
            localStorage.setItem(STORAGE_KEY, theme)
        } catch {
            // Private browsing can block storage; the document theme still applies for this session.
        }
        this.apply(theme)
    }

    private apply(theme: AppTheme): void {
        document.documentElement.dataset.bsTheme = theme
        document.documentElement.style.colorScheme = theme
    }
}

function readStoredTheme(): AppTheme {
    try {
        return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light'
    } catch {
        return 'light'
    }
}
